
import { ENDPOINTS } from "../../apiConfig";
import { showToast } from "../../../components";
import axiosRequest from "../universal/axiosService";

// export const fetchAllPlacements = async (params) => {
//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.get(ENDPOINTS.PLACEMENTS.GET_ALL, {
//       params: {
//         coll: "Placement",
//         lim: 100 || params.limit,
//         pg: 1 || params.page,
//         fil: JSON.stringify(params.fil),
//         cache: params.cache,
//         ref: params.ref,
//         ret: params.ret,
//         incl: params.incl,
//       },
//       headers: {
//         Authorization: `Bearer ${token}`, // Add authorization header
//         "Content-Type": "application/json",
//       },
//       withCredentials: true, // Include cookies if using session-based auth
//     });

//     return response.data;
//   } catch (error) {
//     console.error(error);
//   }
// };
export const fetchAllPlacements = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.PLACEMENTS.GET_ALL,
    params: {
      coll: "Placement",
      lim: params.limit || 100,
      pg: params.page || 1,
      fil: JSON.stringify(params.fil),
      useAggregate: params.useAggregate || false,
      cache: params.cache,
      ref: params.ref,
      ret: params.ret,
      incl: params.incl,
      sort: JSON.stringify(params.sort),
    },
  });
};


// export const fetchPlacements = async (params) => {
//   try {
//     const token = localStorage.getItem("token");

//     const response = await axios.get(ENDPOINTS.PLACEMENTS.GET_BY_UIID, {
//       params: {
//         coll: "Placement",
//         fil: JSON.stringify(params.fil),
//         cache: params.cache,
//         ret: params.ret,
//         ref: params.ref,
//         incl: params.incl,
//       },
//       headers: {
//         Authorization: `Bearer ${token}`, // Add authorization header
//         "Content-Type": "application/json",
//       },
//       withCredentials: true, // Include cookies if using session-based auth
//     });
//     return response.data;
//   } catch (error) {
//     console.error(error);
//     //throw error;
//     // showToast("No Data available", "error", 5000);
//   }
// };
export const fetchPlacements = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
    params: {
      coll: "Placement",
      fil: JSON.stringify(params.fil),
      cache: params.cache,
      ret: params.ret,
      ref: params.ref,
      incl: params.incl,
    },
  });
};

// export const addNewPlacement = async (tPath, placementData) => {
//   try {
//     console.log("placementData", placementData);
//     const token = localStorage.getItem("token");
//     const response = await axios.post(
//       ENDPOINTS.PLACEMENTS.ADD_NEW,
//       {
//         coll: "Placement",
//         payload: placementData,
//         ...(tPath ? { tPath } : {}),
//       },

//       {
//         headers: {
//           Authorization: `Bearer ${token}`, // Add authorization header
//           "Content-Type": "application/json",
//         },
//         withCredentials: true, // Include cookies if using session-based auth
//       }
//     );
//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error(error);
//   }
// };

export const addNewPlacement = async (tPath,patchId, placementData) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.PLACEMENTS.ADD_NEW,
    data: {
      coll: "Placement",
      payload: placementData,
      ...(tPath ? { tPath } : {}),
      ...(patchId ? { patchId } : {}),
    },
  });
};

// export const updatePlacement = async (uiid, payload) => {
//   try {
//     console.log("uiid", uiid);
//     console.log("payload", payload);
//     const token = localStorage.getItem("token");
//     const response = await axios.patch(
//       `${ENDPOINTS.PLACEMENTS.UPDATE}?coll=Placement&uiid=${uiid}`, // Use single `&` not `&&`, and no quotes for "coll"
//       { payload: payload },
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         withCredentials: true,
//       }
//     );
//     return {
//       success: true,
//       data: response.data,
//     };
//   } catch (error) {
//     console.error("Update Placement Error:", error);
//     return {
//       success: false,
//       error:
//         error?.response?.data?.message ||
//         error.message ||
//         "Failed to update placement",
//     };
//   }
// };

export const updatePlacement = async (uiid,patchId, payload) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.PLACEMENTS.UPDATE,
    params: {
      coll: "Placement",
      uiid,
       ...(patchId ? { patchId } : {}),
    },
    data: {
      payload,
    },
  });
};
